import { createAsyncThunk } from "@reduxjs/toolkit";

import { instance } from "../../axios/axios";

// The BFF sends the session JWT in the response's `Authorization: Bearer <jwt>`
// header. Returns the bare token, or null when the header is absent.
export const tokenFromAuthHeader = (headers) => {
  const raw = headers?.authorization ?? headers?.Authorization;
  if (typeof raw !== "string") return null;
  const token = raw.replace(/^Bearer\s+/i, "").trim();
  return token || null;
};

export const login = createAsyncThunk(
  "auth/login",
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const response = await instance.post(
        "user/portal/login",
        { username, password },
        config
      );
      const data = response.data;
      // Header path (preferred): the token authSlice reads (`payload.data.token`)
      // is taken from the Authorization header. Fallback: when the header is
      // absent, the body token already in data.data.token is kept, so a missing
      // header never logs anyone out.
      const headerToken = tokenFromAuthHeader(response.headers);
      if (headerToken && data && data.data && typeof data.data === "object") {
        data.data.token = headerToken;
      }
      return data;
    } catch (error) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

// Exchange a single-use SMS / welcome-email magic-link token for a portal
// session JWT. Public endpoint — the token IS the credential. See
// tech_map/systems/portal/sms-magic-link-spec.md.
export const redeemMagicLink = createAsyncThunk(
  "auth/redeemMagicLink",
  async ({ token }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await instance.post(
        "user/portal/auth/redeem-magic-link",
        { token },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const forgetPassword = createAsyncThunk(
  "auth/forgetPassword",
  async ({ email }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await instance.post(
        "user/portal/forget-password",
        { email },
        config
      );
      return data;
    } catch (error) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
